import { render, staticRenderFns } from "./InvoiceFiles.vue?vue&type=template&id=58c18a90&scoped=true"
import script from "./InvoiceFiles.vue?vue&type=script&lang=js"
export * from "./InvoiceFiles.vue?vue&type=script&lang=js"
import style0 from "./InvoiceFiles.vue?vue&type=style&index=0&id=58c18a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c18a90",
  null
  
)

export default component.exports